/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React Base Styles
import NotoSansTC from "fonts/NotoSansTC-VariableFont_wght.ttf";
import NotoSansSC from "fonts/NotoSansSC-VariableFont_wght.ttf";
import Outfit from "fonts/Outfit-VariableFont_wght.ttf";
import colors from "assets/theme-dark/base/colors";

const { info, white, dark } = colors;

// 2026-05-21 對齊設計系統：dark theme 也載入 Outfit（英數）+ Noto Sans TC（中文）
// 2026-05-25 加 Noto Sans SC（簡體）+ CSS 變數依語系切換
const globals = {
  "@font-face": [
    {
      fontFamily: "Noto Sans TC",
      src: `url(${NotoSansTC}) format("truetype")`,
      fontWeight: "100 900",
      fontDisplay: "swap",
    },
    {
      fontFamily: "Noto Sans SC",
      src: `url(${NotoSansSC}) format("truetype")`,
      fontWeight: "100 900",
      fontDisplay: "swap",
    },
    {
      fontFamily: "Outfit",
      src: `url(${Outfit}) format("truetype")`,
      fontWeight: "100 900",
      fontDisplay: "swap",
    },
  ],
  ":root": {
    "--cjk-font": '"Noto Sans TC"',
  },
  'body[data-lang="zh-CN"]': {
    "--cjk-font": '"Noto Sans SC"',
  },
  html: {
    scrollBehavior: "smooth",
  },
  "*, *::before, *::after": {
    margin: 0,
    padding: 0,
  },
  "a, a:link, a:visited": {
    textDecoration: "none !important",
  },
  "a.link, .link, a.link:link, .link:link, a.link:visited, .link:visited": {
    color: `${dark.main} !important`,
    transition: "color 150ms ease-in !important",
  },
  "a.link:hover, .link:hover, a.link:focus, .link:focus": {
    color: `${info.main} !important`,
  },
};

export default globals;
